import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { inject, observer } from "mobx-react";

import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import ButtonUI from "@UI/ButtonUI";
import { Dropdown } from "primereact/dropdown";

import "./style.scss";
import moment from "moment";
import { useMemo } from "react";

const RatesAddCompanies = inject("mainStore")(
    observer(({ mainStore, ratesDataFilter, error, handleAddRatesCompanies, rateSelect, endElementRateSelect, disableRates, setTypeRates, typeRates }) => {
        const [ratesData, setRatesData] = useState({ item: null, dateStart: null, dateEnd: null });
        // const [typeRates, setTypeRates] = useState("cpa");

        const arr = Object.values(ratesDataFilter).flat();
        const today = moment().startOf("day");

        const computedTypeRates = useMemo(() => {
            return Object.keys(disableRates).find((key) => disableRates[key] !== true);
        }, [disableRates]);

        useEffect(() => {
            setTypeRates(computedTypeRates);
        }, [computedTypeRates]);

        // useEffect(() => {
        //     const firstTrueKey = Object.keys(disableRates).find((key) => disableRates[key] !== true);

        //     setTypeRates(firstTrueKey);
        // }, [disableRates]);

        const filterSelect = ratesDataFilterFunc(arr, rateSelect);

        const isClose = Object.values(filterSelect).flat().length;

        const countryTemplate = (option) => {
            return (
                <div className="multi__item">
                    {option.type === "revenue_share" ? <span style={{ fontWeight: "600" }}>Revenue Share</span> : <span></span>}
                    {option?.type === "revenue_share" ? <span>{option?.percentAmount} %</span> : null}
                    {option?.type === "revenue_share" ? <span>СЧ: {option?.averageBill} ₽ </span> : null}
                    <div>{option.type !== "revenue_share" ? option.rate : null} ₽</div>
                    <div className="multi__item-comment">{option.comments}</div>
                </div>
            );
        };

        const selectTemp = (option) => {
            if (!option) return <div>Выберите из списка</div>;
            return (
                <div className="multi__item">
                    <div>{option.type == "revenue_share" ? option.averageBill : option.rate} ₽</div>
                    <div className="multi__item-comment">{option.comments}</div>
                </div>
            );
        };

        const handleSelect = (e) => {
            setRatesData({ ...ratesData, item: e.value });
        };

        const onChangeCalendar = (value, key) => {
            setRatesData({ ...ratesData, [key]: value });
        };

        const handleTypeRates = (e) => {
            setTypeRates(e.value);
            setRatesData({ item: null, dateStart: null, dateEnd: null });
        };

        const handleAddRates = () => {
            handleAddRatesCompanies(ratesData);
            setRatesData({ item: null, dateStart: null, dateEnd: null });
        };

        return isClose ? (
            <div className="rates__company">
                <div className="rates__company-title">Выберите ставку*</div>
                <div className="radio__block">
                    {radioButton.map((i, idx) => {
                        return (
                            <div className="radio__item" key={idx}>
                                <RadioButton value={i.value} onChange={(e) => handleTypeRates(e)} checked={typeRates == i.value} disabled={disableRates[i.value]} />
                                <label style={disableRates[i.value] ? { color: "#a3a5a7", fontWeight: "500" } : { color: "", fontWeight: "600" }}>{i.label}</label>
                            </div>
                        );
                    })}
                </div>

                {typeRates === "cpa" ? (
                    <div className="multi__block">
                        <label>Ставки вендора*</label>
                        <Dropdown value={ratesData.item} options={filterSelect?.cpa} valueTemplate={selectTemp} itemTemplate={countryTemplate} onChange={handleSelect} appendTo={"self"} placeholder="Выберите из списка" />
                    </div>
                ) : null}
                {typeRates === "accept" ? (
                    <div className="multi__block">
                        <label>Ставки вендора*</label>
                        <Dropdown value={ratesData.item} options={filterSelect?.accept} valueTemplate={selectTemp} itemTemplate={countryTemplate} onChange={handleSelect} appendTo={"self"} placeholder="Выберите из списка" />
                    </div>
                ) : null}
                {typeRates === "cpl" ? (
                    <div className="multi__block">
                        <label>Ставки вендора*</label>
                        <Dropdown value={ratesData.item} options={filterSelect?.cpl} valueTemplate={selectTemp} itemTemplate={countryTemplate} onChange={handleSelect} appendTo={"self"} placeholder="Выберите из списка" />
                    </div>
                ) : null}
                {typeRates === "cpc" ? (
                    <div className="multi__block">
                        <label>Ставки вендора*</label>
                        <Dropdown value={ratesData.item} options={filterSelect?.cpc} valueTemplate={selectTemp} itemTemplate={countryTemplate} onChange={handleSelect} appendTo={"self"} placeholder="Выберите из списка" />
                    </div>
                ) : null}
                {typeRates === "cpm" ? (
                    <div className="multi__block">
                        <label>Ставки вендора*</label>
                        <Dropdown value={ratesData.item} options={filterSelect?.cpm} valueTemplate={selectTemp} itemTemplate={countryTemplate} onChange={handleSelect} appendTo={"self"} placeholder="Выберите из списка" />
                    </div>
                ) : null}
                {typeRates === "revenue_share" ? (
                    <div className="multi__block">
                        <label>Ставки вендора*</label>
                        <Dropdown value={ratesData.item} options={filterSelect?.revenue_share} valueTemplate={selectTemp} itemTemplate={countryTemplate} onChange={handleSelect} appendTo={"self"} placeholder="Выберите из списка" />
                    </div>
                ) : null}
                <div className="block__date">
                    <div className={`date__item`}>
                        <label>Дата начала периода*</label>
                        <Calendar
                            placeholder="Выберите дату"
                            mask={"99.99.9999"}
                            value={ratesData.dateStart}
                            onChange={(e) => onChangeCalendar(e.value, "dateStart")}
                            dateFormat="dd.mm.yy"
                            locale="rus"
                            timeOnly={false}
                            disabled={!ratesData.item}
                            minDate={endElementRateSelect && !moment(endElementRateSelect.dateEnd, "YYYY.MM.DD").isBefore(today, "day") ? moment(endElementRateSelect.dateEnd).add(1, "days").toDate() : moment().toDate()}
                            maxDate={endElementRateSelect?.dateEnd && !endElementRateSelect?.history ? moment(endElementRateSelect?.dateEnd).add(1, "days").toDate() : ""}
                        />
                    </div>

                    <div className={`date__item`}>
                        <label>Дата окончания периода</label>
                        <Calendar
                            placeholder="Бессрочно или выберите дату"
                            mask={"99.99.9999"}
                            value={ratesData.dateEnd}
                            onChange={(e) => onChangeCalendar(e.value, "dateEnd")}
                            dateFormat="dd.mm.yy"
                            locale="rus"
                            timeOnly={false}
                            minDate={moment(ratesData.dateStart).add(1, "days").toDate()}
                            disabled={!ratesData.dateStart}
                        />
                    </div>
                </div>
                <ButtonUI className="button__rate add_rates" label={"Запланировать ставку"} icon="pi pi-calendar" outlined onClick={handleAddRates} style={{ width: "100%" }} disabled={!ratesData.item || !ratesData.dateStart} />
            </div>
        ) : (
            <div className="rates__company">
                <div className="rates__company-title">Нет свободных ставок, добавьте новую ставку</div>
            </div>
        );
    }),
);

const ratesDataFilterFunc = (arr, value) => {
    // const allowedIds = new Set(value.map((v) => v.item._id));

    return arr.reverse().reduce(
        (acc, row) => {
            acc[row.type]?.push(row);
            return acc;
        },
        { cpa: [], accept: [], cpl: [], cpc: [], cpm: [], revenue_share: [] },
    );
};

const tabItems = [
    { label: "Руб. за заказ", key: "rubPerOrder" },
    { label: "Градация ставок", key: "rateGradation" },
    { label: "% от суммы заказа", key: "percentAmount" },
];

const radioButton = [
    { label: "CPA", value: "cpa" },
    { label: "Accept", value: "accept" },
    { label: "CPL", value: "cpl" },
    { label: "CPC", value: "cpc" },
    { label: "CPM", value: "cpm" },
    { label: "Revenue Share", value: "revenue_share" },
];

export default RatesAddCompanies;
